@if (formGroupReady) {
  <form [formGroup]="filtersForm">
    <div class="filters-container">
      @if (filtersToDisplay().includes('deviceIds')) {
        <vectronic-input-filter-with-header
          [title]="FilterTitles.DEVICE_ID"
          [filterValue]="filtersForm.get('deviceIds').value"
          (filterValueChange)="filtersForm.get('deviceIds').setValue($event)"
          (filterEnabled)="filtersForm.get('deviceIdsFilterEnabled').setValue($event)"
          [stringToFilterConverter]="
            InputFilterWithHeaderComponent.stringToNumberArrayFilterConverter
          "
        ></vectronic-input-filter-with-header>
      }

      @if (filtersToDisplay().includes('species')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'species'"
          [filterEnableControl]="'speciesFilterEnabled'"
          [title]="FilterTitles.SPECIES"
          [availableFilterItems]="itemList()"
        />
      }
      @if (filtersToDisplay().includes('networkStatus')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'networkStatus'"
          [filterEnableControl]="'networkStatusFilterEnabled'"
          [title]="FilterTitles.NETWORK_STATUS"
          [availableFilterItems]="FilterList.networkStatusFilterList"
        />
      }
      @if (filtersToDisplay().includes('collarAttached')) {
        <vectronic-single-dropdown-filter
          [filtersForm]="filtersForm"
          [controlName]="'collarAttached'"
          [title]="FilterTitles.COLLAR_ATTACHED"
          [filterEnableControl]="'collarAttachedFilterEnabled'"
        ></vectronic-single-dropdown-filter>
      }
      @if (filtersToDisplay().includes('utc')) {
        <vectronic-utc-filter
          [filtersForm]="filtersForm"
          [lmtFrom]="'lmtFrom'"
          [lmtTo]="'lmtTo'"
          [utcFrom]="'utcFrom'"
          [utcTo]="'utcTo'"
          [recentValue]="'utcRecentValue'"
          [recentUnit]="'utcRecentUnit'"
          [controlName]="'utcMode'"
          [title]="FilterTitles.UTC"
          [filterEnableControl]="'utcFilterEnabled'"
          [isLocalTimeFilterVisible]="isLocalTimeFilterVisible()"
        ></vectronic-utc-filter>
      }
      @if (filtersToDisplay().includes('lastReceptionDate')) {
        <vectronic-last-reception-filter
          [filtersForm]="filtersForm"
          [utcFrom]="'lastReceptionDate'"
          [recentUnit]="'lastReceptionUnit'"
          [title]="FilterTitles.LAST_RECEPTION"
          [filterEnableControl]="'lastReceptionFilterEnabled'"
        ></vectronic-last-reception-filter>
      }
      @if (filtersToDisplay().includes('lastXRecords')) {
        <vectronic-last-x-records-filter
          [filtersForm]="filtersForm"
          [controlName]="'lastXRecords'"
          [title]="FilterTitles.LAST_X_RECORDS"
          [filterEnableControl]="'lastXRecordsFilterEnabled'"
        ></vectronic-last-x-records-filter>
      }
      @if (filtersToDisplay().includes('mapFixType')) {
        <vectronic-map-fix-type-filter
          [filtersForm]="filtersForm"
          [controlName]="'mapFixType'"
          [title]="FilterTitles.FIX_TYPE"
          [filterEnableControl]="'mapFixTypeFilterEnabled'"
        ></vectronic-map-fix-type-filter>
      }
      @if (filtersToDisplay().includes('scts')) {
        <vectronic-utc-filter
          [filtersForm]="filtersForm"
          [lmtFrom]="'sctsLmtFrom'"
          [lmtTo]="'sctsLmtTo'"
          [utcFrom]="'sctsFrom'"
          [utcTo]="'sctsTo'"
          [recentValue]="'sctsRecentValue'"
          [recentUnit]="'sctsRecentUnit'"
          [controlName]="'sctsMode'"
          [title]="FilterTitles.SCTS"
          [filterEnableControl]="'sctsFilterEnabled'"
          [isLocalTimeFilterVisible]="isLocalTimeFilterVisible()"
        ></vectronic-utc-filter>
      }
      @if (filtersToDisplay().includes('utc-trap')) {
        <vectronic-utc-filter
          [filtersForm]="filtersForm"
          [lmtFrom]="'sctsLmtFrom'"
          [lmtTo]="'sctsLmtTo'"
          [utcFrom]="'sctsFrom'"
          [utcTo]="'sctsTo'"
          [recentValue]="'sctsRecentValue'"
          [recentUnit]="'sctsRecentUnit'"
          [controlName]="'sctsMode'"
          [title]="FilterTitles.UTC"
          [filterEnableControl]="'sctsFilterEnabled'"
        ></vectronic-utc-filter>
      }
      @if (filtersToDisplay().includes('latitude')) {
        <vectronic-coordinates-filter
          [filtersForm]="filtersForm"
          [pageName]="pageName()"
          [title]="FilterTitles.COORDINATES"
          [filterEnableControl]="'coordinatesFilterEnabled'"
        ></vectronic-coordinates-filter>
      }
      @if (filtersToDisplay().includes('origin')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'origin'"
          [filterEnableControl]="'originFilterEnabled'"
          [title]="FilterTitles.ORIGIN"
          [availableFilterItems]="FilterList.originFilterList"
        />
      }

      @if (filtersToDisplay().includes('sex')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'sex'"
          [filterEnableControl]="'sexFilterEnabled'"
          [title]="FilterTitles.SEX"
          [availableFilterItems]="FilterList.sexFilterList"
        />
      }
      @if (filtersToDisplay().includes('fixType')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'fixType'"
          [filterEnableControl]="'fixTypeFilterEnabled'"
          [title]="FilterTitles.FIX_TYPE"
          [availableFilterItems]="FilterList.fixTypeFilterList"
        />
      }
      @if (filtersToDisplay().includes('mortalityStatus')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'mortalityStatus'"
          [filterEnableControl]="'mortalityStatusFilterEnabled'"
          [title]="FilterTitles.MORTALITY_STATUS"
          [availableFilterItems]="FilterList.mortalityStatusFilterList"
        />
      }
      @if (filtersToDisplay().includes('vfStatus')) {
        <vectronic-single-dropdown-filter
          [filtersForm]="filtersForm"
          [controlName]="'vfEntered'"
          [title]="FilterTitles.VF_STATUS"
          [filterEnableControl]="'vfEnteredFilterEnabled'"
        ></vectronic-single-dropdown-filter>
      }
      @if (filtersToDisplay().includes('mortalityType')) {
        <vectronic-multi-select-filter
          [filtersForm]="filtersForm"
          [controlName]="'mortalityType'"
          [filterEnableControl]="'mortalityTypeFilterEnabled'"
          [title]="FilterTitles.MORTALITY_TYPE"
        >
        </vectronic-multi-select-filter>
      }
      @if (filtersToDisplay().includes('description')) {
        <vectronic-multi-select-filter
          [filtersForm]="filtersForm"
          [controlName]="'description'"
          [filterEnableControl]="'descriptionFilterEnabled'"
          [title]="FilterTitles.EVENT"
          [pageName]="pageName()"
        >
        </vectronic-multi-select-filter>
      }
      @if (filtersToDisplay().includes('groups')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'groups'"
          [filterEnableControl]="'groupsFilterEnabled'"
          [title]="FilterTitles.GROUPS"
          [availableFilterItems]="groupsList()"
        />
      }
      @if (filtersToDisplay().includes('animalName')) {
        <vectronic-input-search-filter
          [filtersForm]="filtersForm"
          [controlName]="'animalName'"
          [filterEnableControl]="'animalNameFilterEnabled'"
          [title]="FilterTitles.ANIMAL_NAME"
          [pageName]="pageName()"
        >
        </vectronic-input-search-filter>
      }
      @if (filtersToDisplay().includes('invalidPositions')) {
        <vectronic-invalid-positions-filter
          [filtersForm]="filtersForm"
          [title]="FilterTitles.HIDE_INVALID_POSITIONS"
        ></vectronic-invalid-positions-filter>
      }
      @if (filtersToDisplay().includes('localData') && isDesktop) {
        <vectronic-synced-data-filter
          [filtersForm]="filtersForm"
          [title]="FilterTitles.ONLY_LOCAL"
        ></vectronic-synced-data-filter>
      }
      @if (
        filtersToDisplay().includes('downloadTs') &&
        isDesktop &&
        filtersForm.get('onlyLocalData').value
      ) {
        <vectronic-utc-filter
          [filtersForm]="filtersForm"
          [lmtFrom]="'dtsLmtFrom'"
          [lmtTo]="'dtsLmtTo'"
          [utcFrom]="'dtsFrom'"
          [utcTo]="'dtsTo'"
          [recentValue]="'dtsRecentValue'"
          [recentUnit]="'dtsRecentUnit'"
          [controlName]="'dtsMode'"
          [title]="FilterTitles.DOWNLOAD_TS"
          [filterEnableControl]="'dtsFilterEnabled'"
          [isLocalTimeFilterVisible]="isLocalTimeFilterVisible()"
        ></vectronic-utc-filter>
      }
      @if (filtersToDisplay().includes('showSystemLog') && isDesktop) {
        <vectronic-show-system-log-filter
          [filtersForm]="filtersForm"
          [title]="FilterTitles.SHOW_SYSTEM_LOG"
        ></vectronic-show-system-log-filter>
      }
      @if (filtersToDisplay().includes('deviceType')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'deviceType'"
          [filterEnableControl]="'deviceTypeFilterEnabled'"
          [title]="FilterTitles.DEVICE_TYPE"
          [availableFilterItems]="itemList()"
        />
      }
      @if (filtersToDisplay().includes('motionDataType')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'motionDataType'"
          [filterEnableControl]="'motionDataTypeFilterEnabled'"
          [title]="FilterTitles.MOTION_DATA_TYPE"
          [availableFilterItems]="itemList()"
        />
      }
      @if (filtersToDisplay().includes('comType')) {
        <vectronic-multi-select-chip-filter
          [filtersForm]="filtersForm"
          [controlName]="'comType'"
          [filterEnableControl]="'comTypeFilterEnabled'"
          [title]="FilterTitles.COM_TYPE"
          [availableFilterItems]="FilterList.comTypeFilterList"
        />
      }
      @if (filtersToDisplay().includes('deployedOnly')) {
        <vectronic-deployed-only
          [filtersForm]="filtersForm"
          [controlName]="'deployedOnlyFilterEnabled'"
          [title]="FilterTitles.DEPLOYED_ONLY"
          [filterEnableControl]="'deployedOnlyFilterEnabled'"
        ></vectronic-deployed-only>
      }
    </div>
    @if (!isCollarOrAnimalPage()) {
      <div class="d-flex justify-content-between btn-container">
        <button mat-button color="accent" class="w-100" type="submit" (click)="onApply()">
          <mat-icon>check_circle</mat-icon>
          Apply
        </button>
        <button mat-button color="warn" class="w-100" type="reset" (click)="onReset()">
          <mat-icon>cancel</mat-icon>
          Reset
        </button>
      </div>
    }
  </form>
}
